const AUTH_KEY = 'mosidaAuthUser';

function readFromStorage(storage) {
  try {
    const raw = storage.getItem(AUTH_KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    if (!parsed || typeof parsed !== 'object') return null;
    const user = parsed.user || parsed;
    const id = user.id || user.user_id || user.userId || parsed.userId;
    if (!id) return null;
    return {
      token: parsed.token || parsed.access_token || '',
      user: { ...user, id },
    };
  } catch {
    return null;
  }
}

export function readAuthSession() {
  return readFromStorage(sessionStorage) || readFromStorage(localStorage);
}

export function saveAuthSession(session) {
  const user = session && typeof session === 'object' ? session.user : null;
  const token = session && typeof session === 'object' ? session.token || '' : '';
  if (!user) {
    try {
      sessionStorage.removeItem(AUTH_KEY);
      localStorage.removeItem(AUTH_KEY);
    } catch {
      /* ignore */
    }
    return null;
  }
  const next = { token, user };
  try {
    sessionStorage.setItem(AUTH_KEY, JSON.stringify(next));
    localStorage.setItem(AUTH_KEY, JSON.stringify(next));
  } catch {
    /* ignore */
  }
  return next;
}

export function clearAuthSession() {
  saveAuthSession(null);
}
